export default "assets/images/icons/infos-4b2a28b3.svg";